import React from 'react';
import { useParams, Link } from 'react-router-dom';
import TestInterface from '../components/TestInterface';

const KioskTest: React.FC = () => {
  const { testId } = useParams<{ testId: string }>();

  // Retrieve test duration and type from sessionStorage
  const kioskSession = sessionStorage.getItem('kioskSession');
  const parsedSession = kioskSession ? JSON.parse(kioskSession) : null;
  const testDurationMinutes = parsedSession?.testDurationMinutes ?? 5;
  const testDurationMs = testDurationMinutes * 60 * 1000;
  const testType = parsedSession?.testType === 'LETTER' ? 'LETTER' : 'CHECKERBOARD';
  const isMockup = parsedSession?.isMockup === true;

  if (!testId) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-navy-950 via-navy-900 to-navy-800">
        <div className="text-center text-navy-200">
          <p className="mb-4">Test session not found.</p>
          <Link to="/kiosk/start" className="text-gold-400 underline">
            Return to start
          </Link>
        </div>
      </div>
    );
  }

  return (
    <TestInterface
      testId={testId}
      userType="kiosk"
      testConfig={{ testDuration: testDurationMs, testType, isMockup }}
    />
  );
};

export default KioskTest;
